"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CtaButton_1 = require("../common/Btn/CtaButton");
var media_query_1 = require("../../hooks/media-query");
var react_1 = require("swiper/react");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var Parser_1 = require("../Parser");
var doctor_module_1 = require("../../utils/shopify-graphql/doctor-module");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var DoctorModule = function () {
    var _a, _b, _c;
    var _d = (0, hooks_1.useState)(null), data = _d[0], setData = _d[1];
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, doctor_module_1.getDoctorModuleData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (data && (data === null || data === void 0 ? void 0 : data.doctors.length) <= 3) {
        return ((0, preact_1.h)("div", { className: "doctor-module" },
            (0, preact_1.h)("p", { className: "doctor-module__header" },
                "Our Medical ",
                (0, preact_1.h)("br", { className: "hide-on-desktop" }),
                "Advisory Board"),
            !isDesktop && ((0, preact_1.h)(react_1.Swiper, { loop: true },
                (0, preact_1.h)(SwiperNavArrows_1.default, { bgColor: data === null || data === void 0 ? void 0 : data.color }), (_a = data === null || data === void 0 ? void 0 : data.doctors) === null || _a === void 0 ? void 0 :
                _a.map(function (c) { return ((0, preact_1.h)(react_1.SwiperSlide, { key: c.doctorName },
                    (0, preact_1.h)("div", { className: "doctor-module__content" },
                        (0, preact_1.h)("img", { className: "doctor-module__image", src: c.doctorImage }),
                        (0, preact_1.h)("p", { className: "doctor-module__name" }, c.doctorName && (0, Parser_1.parse)(c.doctorName)),
                        (0, preact_1.h)("p", { className: "doctor-module__specialty" }, c.doctorSpecialty && (0, Parser_1.parse)(c.doctorSpecialty)),
                        (0, preact_1.h)("p", { className: "doctor-module__quote" }, c.doctorQuote && (0, Parser_1.parse)(c.doctorQuote))))); }),
                (0, preact_1.h)("div", { className: "doctor-module__cta" }, (data === null || data === void 0 ? void 0 : data.ctaColor) && ((0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                        to: 'Left',
                        startColor: data.ctaColor.backgroundStart || 'white',
                        endColor: data.ctaColor.backgroundEnd,
                    }, hoverColor: data.ctaColor.hover, text: "SHOP NOW", scrollTo: "/collections/shop-all" }))))),
            isDesktop && ((0, preact_1.h)("div", { className: "doctor-module__desktop-container" }, (_b = data === null || data === void 0 ? void 0 : data.doctors) === null || _b === void 0 ? void 0 : _b.map(function (c) { return ((0, preact_1.h)("div", { className: "doctor-module__content", key: c.doctorName },
                (0, preact_1.h)("img", { className: "doctor-module__image", src: c.doctorImage }),
                (0, preact_1.h)("p", { className: "doctor-module__name" }, c.doctorName && (0, Parser_1.parse)(c.doctorName)),
                (0, preact_1.h)("p", { className: "doctor-module__specialty" }, c.doctorSpecialty && (0, Parser_1.parse)(c.doctorSpecialty)),
                (0, preact_1.h)("p", { className: "doctor-module__quote" }, c.doctorQuote && (0, Parser_1.parse)(c.doctorQuote)))); })))));
    }
    else {
        return ((0, preact_1.h)("div", { className: "doctor-module doctor-module--page" },
            (0, preact_1.h)("p", { className: "doctor-module__header" }, (data === null || data === void 0 ? void 0 : data.header) && (0, Parser_1.parse)(data.header)),
            (0, preact_1.h)(react_1.Swiper, { loop: true, centeredSlides: true, slidesPerView: 1, breakpoints: {
                    1025: {
                        slidesPerView: 3,
                    },
                } },
                (0, preact_1.h)(SwiperNavArrows_1.default, null), (_c = data === null || data === void 0 ? void 0 : data.doctors) === null || _c === void 0 ? void 0 :
                _c.map(function (c) { return ((0, preact_1.h)(react_1.SwiperSlide, { key: c.doctorName },
                    (0, preact_1.h)("div", { className: "doctor-module__content" },
                        (0, preact_1.h)("img", { className: "doctor-module__image", src: c.doctorImage }),
                        (0, preact_1.h)("p", { className: "doctor-module__name" }, c.doctorName && (0, Parser_1.parse)(c.doctorName)),
                        (0, preact_1.h)("p", { className: "doctor-module__specialty" }, c.doctorSpecialty && (0, Parser_1.parse)(c.doctorSpecialty)),
                        (0, preact_1.h)("p", { className: "doctor-module__quote" }, c.doctorQuote && (0, Parser_1.parse)(c.doctorQuote))))); })),
            (0, preact_1.h)("div", { className: "doctor-module__cta" }, (data === null || data === void 0 ? void 0 : data.ctaColor) && ((0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                    to: 'Left',
                    startColor: data.ctaColor.backgroundStart || 'white',
                    endColor: data.ctaColor.backgroundEnd,
                }, hoverColor: data.ctaColor.hover, text: "SHOP NOW", scrollTo: "/collections/shop-all" })))));
    }
};
exports.default = DoctorModule;
